export default function openUrlInNewTab(url: string): void {
  const newTab = window.open(url, "_blank");
  newTab?.focus();
}
// test azure
